import * as React from "react";
import {
  DialogContent,
  Drawer as MUIDrawer,
  DrawerProps,
} from "@material-ui/core";

interface Props {
  DrawerProps: DrawerProps;
}

const Drawer: React.FC<Props> = ({ DrawerProps, children }) => {
  return (
    <MUIDrawer {...DrawerProps}>
      <DialogContent style={{ maxWidth: "80vw" }}>{children}</DialogContent>
    </MUIDrawer>
  );
};

export default Drawer;
